import validators from '../../utils/validators';

class StrategyGoal {
  static STATUS_NEW = 'new';
  static STATUS_ACHIEVED = 'achieved';
  static STATUS_CANCELED = 'canceled';

  /**
   * @param data
   */
  constructor(data) {
    const properties = {
      id: (v) => validators.isNotEmptyString(v),
      strategy: (v) => validators.isNotEmptyString(v),
      note: (v) => validators.isStringOrNull(v),
      status: (v) => validators.isNotEmptyString(v),
    };

    for (const property of Object.keys(properties)) {
      if (properties[property](data[property]) !== true) {
        throw new Error(`Invalid StrategyGoal property '${property}' in ${data.id}`);
      }

      this[property] = data[property];
    }
  }

  isAchieved() {
    return this.status === StrategyGoal.STATUS_ACHIEVED;
  }

  isCanceled() {
    return this.status === StrategyGoal.STATUS_CANCELED;
  }

  isUnfinished() {
    return !this.isAchieved() && !this.isCanceled();
  }
}

export default StrategyGoal;
